import { render, staticRenderFns } from "./SingleRoundButton.vue?vue&type=template&id=235dbb36&scoped=true&"
import script from "./SingleRoundButton.vue?vue&type=script&lang=js&"
export * from "./SingleRoundButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235dbb36",
  null
  
)

export default component.exports